module.exports = __webpack_public_path__ + "static/media/ice_effect.95e83315.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sound/ice_effect.mp3
// module id = 32
// module chunks = 0